/* 

Animated checkmark
By LP
-> A circle that is drawn first, followed by the checkmark
-> ACTIVE

*/

import React from 'react';
import { motion } from 'framer-motion';

export const CheckmarkAnimation: React.FC = () => {

    const circleVariant = {
        hidden: { pathLength: 0 },
        visible: {
            pathLength: 1,
            transition: { duration: 1 }
        }
    };

    const checkVariant = {
        hidden: { pathLength: 0, opacity: 0 },
        visible: {
            pathLength: 1,
            opacity: 1,
            transition: { delay: 1, duration: 0.8, ease: "easeInOut" }
        }
    };

    return (
        <motion.div
            animate={{
                scale: [1, 1.05, 1],
            }}
            transition={{
                delay: 2.0,
                duration: 0.6,
                ease: "easeInOut"
            }}
        >
            <motion.div
                style={{
                    filter: "drop-shadow(0px 0px 3px rgba(61, 220, 132, 0.5))",
                    width: "200px",
                    height: "200px",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center"
                }}
            >
                <svg width="200" height="200" xmlns="http://www.w3.org/2000/svg">
                    <defs>
                        <linearGradient id="circleGradient" x1="0%" y1="0%" x2="100%" y2="0%">
                            <stop offset="0%" stopColor="#3DDC84" />
                            <stop offset="100%" stopColor="#3ECB8A"/>
                        </linearGradient>
                    </defs>

                    {/* Only the circle rotates now */}
                    <motion.g
                        initial={{ rotate: 0 }}
                        animate={{ rotate: 360 }}
                        transition={{ repeat: Infinity, duration: 10, ease: "linear" }}
                        origin="50% 50%"
                    >
                        <motion.circle
                            cx="100"
                            cy="100"
                            r="90"
                            fill="transparent"
                            stroke="url(#circleGradient)"
                            strokeWidth="5"
                            strokeLinecap="round"
                            initial="hidden"
                            animate="visible"
                            variants={circleVariant}
                        />
                    </motion.g>

                    {/* Checkmark stays static */}
                    <motion.path
                        fill="transparent"
                        stroke="#3DDC84"
                        strokeWidth="14"
                        strokeLinecap="round"
                        d="M60 100 L90 130 L140 70"
                        initial="hidden"
                        animate="visible"
                        variants={checkVariant}
                    />
                </svg>
            </motion.div>
        </motion.div>
    );
};

export default CheckmarkAnimation;